import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';

import axios from 'axios';
import { useParams } from 'react-router-dom';
import { fetchStockMemoNo } from '../../Store/PHPSlice/Stock/StockApis';
import { selectStockMemoNo } from '../Selectors/StitchSelector/StitchingSelectors';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import { selectlocationdata, selectRack } from '../Selectors/Master/ItemSelectors';
import Dropdown from '../FieldsComponents/Dropdown';


const PackFlowInward = () => {

    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        pkid: Id,
        memo: '',
        empNm: '',
        totQty: '',
        stkMemo: '',
        userId: userdata?.ID
    });
    const [loading, setLoading] = useState(false);
    const [itemSize, setItemSize] = useState([]);

    const dispatch = useDispatch();
    const [packdata, setPackdata] = useState([]);

    const stockMemo = useSelector(selectStockMemoNo);
    const racklist = useSelector(selectRack);
    const loclist = useSelector(selectlocationdata);

    useEffect(() => {
        fetchPackFlowWise(Id);
        dispatch(fetchStockMemoNo());
        dispatch(fetchRackData());
        dispatch(fetchLocationData());
    }, [Id]);

    useEffect(() => {
        if (stockMemo?.data) {
            const item = stockMemo?.data?.stkMemo;
            setFormData(prev => ({
                ...prev,
                stkMemo: item
            }));
        }
    }, [stockMemo]);

    const fetchPackFlowWise = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getFlowWisePackingReg&pkid=${id}`);
            const item = res.data?.data;
            const info_totqty = res.data?.info.reduce((a, s) => a + Number(s.inwqty || 0), 0);
            setFormData(prev => ({
                ...prev,
                empId: item.empId,
                empNm: item.empNm,
                firmId: item.firmId,
                fpkmemo: item.fpkmemo,
                instruction: item.instruction,
                itemId: item.itemId,
                itemNm: item.itemNm,
                m1: item.m1,
                m1clothNm: item.m1clothNm,
                m2: item.m2,
                m2clothNm: item.m2clothNm,
                m3: item.m3,
                m3clothNm: item.m3clothNm,
                mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                ordtype: item.ordtype,
                prnId: item.prnId,
                prnMemo: item.prnMemo,
                reMemo: item.reMemo,
                soId: item.soId,
                sono: item.sono,
                stinwId: item.stinwId,
                totqty: item.totqty,
                memo: item?.countMemo > 0 ? `R-${item.fpkmemo}-${item.countMemo}` : `R-${item.fpkmemo}`,
                departId: item.departId,
                totinwqty: info_totqty
            }))
            setPackdata(res.data.info);
        } catch (error) {
            console.error('error', error);
        }
    };
    // console.log(packdata);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handlePackInputChange = (index, field, value) => {
        setPackdata(prev => {
            const rows = [...prev];
            const row = rows[index];

            const numericValue = Number(value) || 0;
            const gqty = Number(row.gqty) || 0;
            const inwqty = field === 'inwqty' ? numericValue : Number(row.inwqty) || 0;
            const dqty = field === 'dqty' ? numericValue : Number(row.dqty) || 0;

            // individual validation
            if (numericValue > gqty) {
                alert(`${field === 'inwqty' ? 'Inward' : 'Damage'} Qty cannot be greater than Issue Qty (${gqty})`);
                return prev;
            }

            // combined validation
            if (inwqty + dqty > gqty) {
                alert(`Inward + Damage Qty cannot exceed Issue Qty (${gqty})`);
                return prev;
            }

            const balQty = gqty - (inwqty + dqty);

            rows[index] = {
                ...row,
                inwqty,
                dqty,
                bqty: balQty
            };

            // 🔥 calculate total inward qty
            const totalInwQty = rows.reduce(
                (sum, r) => sum + (Number(r.inwqty) || 0),
                0
            );

            // 🔥 update formData safely
            setFormData(fd => ({
                ...fd,
                totinwqty: totalInwQty
            }));

            return rows;
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    }

    const dropdownLocationRack = [
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.locNm : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.locNm === value.locNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.locNm === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Rack',
            id: 'rackId',
            options: racklist?.data || [],
            value: formData.rackId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'rackId', value: newValue ? newValue.rackNm : '' } }, 'rackId'),
            getOptionLabel: (option) => option.rackNm || '',
            isOptionEqualToValue: (option, value) => option.rackNm === value.rackNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.rackNm === value) || null;
                }
                return null;
            },
        }
    ];

    const postObj = (formData, packdata) => {
        const data = {
            fpkinwMemo: formData.memo,
            stkmemo: formData.stkMemo,
            dt: formData.dt,
            pkid: formData.pkid,
            firmId: formData.firmId,
            soId: formData.soId,
            totqty: formData.totqty,
            inwqty: formData.totinwqty,
            userId: formData.userId,
            itemId: formData.itemId,
            mcloth: formData.mcloth,
            m1: formData.m1,
            m2: formData.m2,
            m3: formData.m3,
            locNm: formData.locId,
            rack: formData.rackId,
            packdata: packdata,
            departId: formData.departId
        };
        return data;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const finalObj = postObj(formData, packdata);
            // console.log(finalObj);

            const result = await axios.post(`${baseUrl}?apicall=insertFlowWisePackingInwardEntry`, finalObj);
            const data = result?.data;
            // console.log(data);
            if (data.status === "success") {
                alert(data.msg);
                window.opener.postMessage("REFRESH_PARENT", "*");
                window.close();
            } else {
                const msg = Array.isArray(data.msg) ? data.msg.join("\n") : data.msg;
                alert(msg);
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Packing Inward</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Inward Memo No', name: 'memo', type: 'readOnly' },
                                    { label: 'SO', name: 'sono', type: 'readOnly' },
                                    { label: 'Order Type', name: 'ordtype', type: 'readOnly' },
                                    { label: 'Iron Inward', name: 'prnMemo', type: 'readOnly' },
                                    { label: 'Stitching Inward', name: 'reMemo', type: 'readOnly' },
                                    { label: 'Item', name: 'itemNm', type: 'readOnly' },
                                    { label: 'Main Cloth', name: 'mclothNm', type: 'readOnly' },
                                    { label: 'Match-1', name: 'm1clothNm', type: 'readOnly' },
                                    { label: 'Match-2', name: 'm2clothNm', type: 'readOnly' },
                                    { label: 'Match-3', name: 'm3clothNm', type: 'readOnly' },
                                    { label: 'Total Qty.', name: 'totqty', type: 'readOnly' },
                                    { label: 'Total Inward Qty.', name: 'totinwqty', type: 'readOnly' },
                                    { label: 'Stock Memo', name: 'stkMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {
                                    dropdownLocationRack && dropdownLocationRack?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                <table>
                                    <thead>
                                        <th>Sr.No.</th>
                                        <th>Barcode</th>
                                        <th>size</th>
                                        <th>Issue Qty</th>
                                        <th>Inw Qty</th>
                                        <th>Damage Qty</th>
                                        <th>Bal Qty</th>
                                    </thead>
                                    <tbody>
                                        {packdata.filter(a => a.gqty > 0)
                                            .map((i, idx) => (
                                                <tr key={idx}>
                                                    <td>{idx + 1}</td>
                                                    <td>{i.barcode}</td>
                                                    <td>{i.size}</td>
                                                    <td>{i.gqty}</td>
                                                    <td>
                                                        <input type="text"
                                                            name='inwqty'
                                                            value={i.inwqty}
                                                            onChange={(e) =>
                                                                handlePackInputChange(idx, 'inwqty', e.target.value)
                                                            }
                                                            style={{ width: '100px', padding: '2px' }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input type="text"
                                                            name='dqty'
                                                            value={i.dqty}
                                                            onChange={(e) =>
                                                                handlePackInputChange(idx, 'dqty', e.target.value)
                                                            }
                                                            style={{ width: '100px', padding: '2px' }}
                                                        />
                                                    </td>
                                                    <td>{i.bqty}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PackFlowInward;
